const initialState = {
  employee_profile: [],
  employee_data: null,
  combined_employee_data: null,
  isLoding : false
 
};

const EmployeeProfileApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_EMPLOYEE_PROFILE_DETAILS_SUCCESS":
      return {
        ...state,
        employee_profile: action.payload,
        error: null
      };
    case "GET_EMPLOYEE_PROFILE_DETAILS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_EMPLOYEE_PROFILE_DETAILS_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_EMPLOYEE_PROFILE_DETAILS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    
    case "GET_EMPLOYEES_SUCCESS":
      return {
        ...state,
        employee_data: action.payload,
        error: null
      };
    case "GET_EMPLOYEES_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_EMPLOYEE_SUCCESS":
      return {
        ...state,
        employee_data: action.payload,
        
        error: null
      };
    case "ADD_EMPLOYEE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_EMPLOYEE_SUCCESS":
      return {
        ...state,
        employee_data: action.payload,
        // error: action.payload.error
      };

    case "UPDATE_EMPLOYEE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "DELETE_EMPLOYEE_SUCCESS":
      return {
        ...state,
        employee_data: action.payload,

        error: null
      };

    case "DELETE_EMPLOYEE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_COMBINED_EMPLOYEE_DATA_SUCCESS":
      return {
        ...state,
        employee_data: action.payload,
        error: null
      };
    case "ADD_COMBINED_EMPLOYEE_DATA_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };


    default:
      return state;
  }
};

export default EmployeeProfileApiReducer;
